<template>
  <div>
    <div v-if="showPlans" class="mb-4 text-left">
      <h4>Please Choose a Membership Plan</h4>
      <select id="planId"
              v-model="planChosen"
              class="material-input form-control">
        <option v-for="opt in choicePlans" :value="opt.id">{{ opt.planName }} ({{ opt.price }})</option>
      </select>
      <mdb-btn :disabled="!planChosen" icon="check" @click="submitPlan">Submit</mdb-btn>
    </div>
    <div v-if="questions.length>0 && !showPlans" class="mb-4 text-left">
      <custom-data :custom-data="questions" allow-edit force-edit help-text-as-label is-self @dataSaved="customDataSaved"/>
      <mdb-btn v-if="!hideCancel" icon="minus-circle" size="sm" color="danger" rounded @click="cancel">Cancel</mdb-btn>
    </div>
    <div v-if="questions.length==0">
      {{ group.name }} doesn't have any questions to ask.
    </div>
  </div>

</template>

<script>
import {mdbBadge, mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbCheckbox, mdbIcon, mdbInput} from 'mdbvue';
import api from '../../services/groupsPlaceApi.js'
import CustomData from "../common/CustomData";

export default {
  name: 'group-questions',
  components: {
    mdbIcon,
    mdbInput,
    mdbBtn,
    mdbCheckbox,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbBadge,
    CustomData
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    subscriptions: {
      type: Boolean,
      default: true
    },
    showAll: {
      type: Boolean,
      default: true
    },
    hideCancel: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      currentQuestionNum: 0,
      questions: [],
      choicePlans: [],
      planChosen: null,
      showPlans: false
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    api.get("/group/getQuestions/" + this.group.vanityPath).then(
      (response) => {
        this.questions = response.data.questions
        this.choicePlans = response.data.choicePlans
        if (this.choicePlans.length > 0) this.showPlans = true
          /*if (this.showAll || foundAns.forceReAnswer || !foundAns.id) {
            this.questions.push(q)
            this.answers.push(foundAns)
          }*/

      },
      (error) => {
        this.$notify.error({message: "Could not fetch questions at this time."})
      }
    ).then(() => {
             this.$store.dispatch("setExecuting", false)
           }
    );
  },
  methods: {
    submitPlan: function () {
      api.post("/member/setMembershipPlan/" + this.group.vanityPath, {
        planId: this.planChosen,
        startDate: new Date()
      }).then(
        (response) => {
          this.showPlans = false
          if (this.maySubmit) {
            this.$emit("submit", null)
          }
        },
        (error) => {
          this.$notify.error({message: "Could not set plan at this time."})
        }
      ).then(() => {
               this.$store.dispatch("setExecuting", false)
             }
      );
    },
    customDataSaved(results) {
      this.$emit("submit", results)
    },
    cancel() {
      this.$router.push("/")
    }
  }
};
</script>

<style scoped>
.question-badge {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
